import React, { Dispatch, SetStateAction } from 'react';
import { gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

import { Text } from '@reckon-web/text';
import { AlertDialog } from '@reckon-web/modal-dialog';
import { useToasts } from '@reckon-web/toast';

import { User } from '../../types';

const RESEND_EMAIL = gql`
  mutation ResendEmail($input: String!) {
    emailResend(email: $input)
  }
` as import('../../../../../__generated__/ts-gql/ResendEmail').type;

type ResendInviteDialogProps = {
  editUser: User | null;
  isResendDialogOpen: boolean;
  setResendDialogOpen: Dispatch<SetStateAction<boolean>>;
};

export const ResendInviteDialog = ({
  editUser,
  setResendDialogOpen,
  isResendDialogOpen,
}: ResendInviteDialogProps) => {
  const { addToast } = useToasts();
  const [resendEmail, resendStatus] = useMutation(RESEND_EMAIL);

  const resendEmailActions = {
    confirm: {
      label: 'Continue',
      action: () => {
        const { email } = { ...editUser };
        if (!email) return;

        resendEmail({
          variables: {
            input: email,
          },
        }).then(() => {
          setResendDialogOpen(false);
          addToast({
            title: 'Resend email success',
            message:
              'The user should expect to see a verification email in their inbox ',
            tone: 'positive',
          });
        });
      },
      loading: resendStatus?.loading,
    },
    cancel: { label: 'Cancel', action: () => setResendDialogOpen(false) },
  };

  return (
    <AlertDialog
      actions={resendEmailActions}
      isOpen={isResendDialogOpen}
      title="Resend verification email"
    >
      <Text>
        A new verification email will be sent to {editUser?.email} with
        instructions on completing the sign up process
      </Text>
    </AlertDialog>
  );
};
